import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=7931dddc&scoped=true"
import script from "./dataStatistics.vue?vue&type=script&lang=js"
export * from "./dataStatistics.vue?vue&type=script&lang=js"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=7931dddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931dddc",
  null
  
)

export default component.exports